var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChairIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.02 6.845V2.73a2.771 2.771 0 0 0-2.834-2.7h-6.8a2.771 2.771 0 0 0-2.834 2.698v4.114H1.454A1.438 1.438 0 0 0 .019 8.278v7.742A1.083 1.083 0 0 0 1.1 17.103h.529v2.057a.361.361 0 0 0 .36.361h1.393a.36.36 0 0 0 .35-.278l.506-2.14h9.095l.506 2.14a.36.36 0 0 0 .35.278h1.393a.361.361 0 0 0 .36-.36v-2.058h.53a1.083 1.083 0 0 0 1.082-1.083V8.28a1.438 1.438 0 0 0-1.436-1.435H15.02z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.596 1.698c.45-.014.888.15 1.217.456.329.306.523.73.539 1.177v3.42a1.181 1.181 0 0 0-1.053 1.173v3.773H5.24V7.923c-.002-.29-.11-.57-.303-.785a1.193 1.193 0 0 0-.75-.388V3.331c.015-.448.21-.871.539-1.177a1.71 1.71 0 0 1 1.216-.456h5.655z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.852 14.723c0 .081-.034.16-.093.217a.323.323 0 0 1-.225.09H2.003a.313.313 0 0 1-.318-.307V8.97c0-.16.067-.315.184-.429a.64.64 0 0 1 .444-.178h.62a.64.64 0 0 1 .444.178.598.598 0 0 1 .184.43v4.189c0 .081.034.16.093.217.06.058.14.09.225.09h9.776a.323.323 0 0 0 .225-.09.302.302 0 0 0 .093-.217V8.97c0-.16.066-.315.184-.429a.64.64 0 0 1 .444-.178h.62a.64.64 0 0 1 .444.178.597.597 0 0 1 .184.43l.003 5.752z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChairIcon1);
export default __webpack_public_path__ + "static/media/chair-icon-1.5ca43a9ed574f79bf3069c472ff57005.svg";
export { ForwardRef as ReactComponent };